import React from 'react'
import imgs from './assets/images/404.svg'
const NoMatch = () => {
  return (
    <div className='w-100 vh-100 d-grid justify-content-center align-items-center'  >
      <div className='text-center fw-bold' style={{fontSize:'20px'}}>
        Page Not Found!
        <img src={imgs} alt='' className='w-100' />
      </div>
    </div>
  )
}

export default NoMatch
